export default "__VITE_ASSET__VaEXenaJ__"